import { useEffect } from 'react';

export const useSwarmSignalR = (signalRConnection, handlers) => {
  useEffect(() => {
    if (!signalRConnection) return;
    //TODO: we need to add handlers for EditSwarmBuyRequest 
    const eventHandlers = {
      'EditSwarmEvent': handlers.handleEditSwarmEvent,
      'CreateSwarmBuyRequest': handlers.handleNewBuyRequestEvent,
      'AcceptedSwarmBuyRequest': handlers.handleAcceptedBuyRequestEvent,
      'LostSwarmBuyRequest': handlers.handleLostBuyRequestEvent,
      'CompletedSwarmBuyRequest': handlers.handleCompletedBuyRequestEvent,
      'RejectedSwarmBuyRequest': handlers.handleRejectedSwarmBuyRequestEvent,
      'CanceledByBeeSwarmBuyRequest': handlers.handleCanceledByBeeSwarmBuyRequestEvent,
    };
    
    // Attach handlers
    Object.entries(eventHandlers).forEach(([event, handler]) => {
      signalRConnection.on(event, handler);
    });
    
    // Cleanup
    return () => {
      if (signalRConnection) {
        Object.entries(eventHandlers).forEach(([event, handler]) => {
          signalRConnection.off(event, handler);
        });
      }
    };
  }, [signalRConnection, handlers]);
};
